<template lang="pug">
dv-menu(
  v-model="menu"
  left
  :close-on-content-click="false"
)
  template(#activator="{ attrs, on }")
    v-sheet.rounded-pill.ui-background.pa-1.d-flex.align-center.gap-8.pointer(
      :height="36"
      v-on="on"
    )
      app-avatar.rounded-circle.header-user-data__avatar(
        :size="32"
        :avatar="avatar"
      )
      v-icon.mr-2(color="ui-neutral" :size="20") $ui-bars-3
  v-list.ui-body-1.pb-0
    template(v-if="connectedToUser")
      v-list-item(
        :disabled="Boolean(authLoadingRoleKey)"
        @click="authAsConnectedUser"
      )
          v-icon(:size="20" ) $iuser
          div.ml-4
            .ui-body-1
              | Вернуться в кабинет участника
    template(v-if="links.length")
      v-list-item(
        v-for="(link, idx) in links"
        :key="idx"
        :to="link.to"
        :class="link.class"
        color="ui-primary"
        v-on="link.listeners"
        @click="menu = false"
      )
        v-icon(:size="20") {{ link.icon }}
        p.ml-4 {{ link.text }}

    template(v-if="connectedRoleItems.length")
      v-list-group(
        v-model="roleSwitchOpened"
      )
        template(#activator)
          v-icon(size="20") $iuser
          p.ml-4 Переключить роль
        v-list-item.pl-4(
          v-for="roleItem in connectedRoleItems"
          :key="roleItem.key"
          :disabled="Boolean(authLoadingRoleKey && authLoadingRoleKey !== roleItem.key)"
          @click="authAsConnectedRole(roleItem)"
        )
          v-progress-circular(
            v-if="authLoadingRoleKey === roleItem.key"
            indeterminate
            size="20"
            width="2"
            color="ui-primary"
          )
          v-icon(v-else size="20") $iuser
          p.ml-4 {{ roleItem.text }}
    v-list-item.ui-error--text(
      @click="logout"
    )
      v-icon(size="20") $iexit
      p.ml-4 Выйти
</template>

<script>
import AppAvatar from '@/components/user-redesign/AppAvatar.vue';
import DvMenu from '@/packages/ui/components/menus/DvMenu.vue';

const ROLE_CONFIG = {
  trainer: {
    text: 'Наставник',
    route: '/my-profile',
  },
  expert: {
    text: 'Эксперт',
    route: '/redesign/my-profile',
  },
  event_manager: {
    text: 'Менеджер мероприятий',
    route: '/my-profile',
  },
};

const CONNECTED_TO_USER_KEY = 'connected_to_user';

export default {
  components: {
    AppAvatar,
    DvMenu,
  },
  props: {},
  inject: {
    openInstructions: {
      from: 'openInstructions',
      default: () => null,
    },
  },
  data() {
    return {
      CONNECTED_TO_USER_KEY,
      menu: false,
      roleSwitchOpened: false,
      authLoadingRoleKey: undefined,
    };
  },
  computed: {
    connectedToUser() {
      return this.$user.connectedToUser || null;
    },
    associations() {
      return Object.values(this.$store.getters?.['association/value']);
    },
    connectedToUserLabel() {
      const user = this.connectedToUser || {};
      return user.full_name || user.username || 'Привязанный пользователь';
    },
    avatar() {
      const { profile, organizer } = this.$user?.data || {};
      const base = profile || organizer || {};
      return base?.avatar || {};
    },
    links() {
      const {
        isAuthenticated,
        isOrganization,
        isOperator,
        isDepartment,
        isExpert,
        isMember,
      } = this.$user || {};
      return [
        // ...isClub ? [{
        //   icon: '$ui-deal',
        //   to: { name: 'ui-my-club' },
        //   text: 'Мой клуб',
        // }] : [],
        ...isExpert && !this.connectedToUser ? [{
          icon: '$iuser',
          to: { name: 'ui-my-profile' },
          text: 'Профиль',
        }] : [],
        ...isOrganization ? [
          {
            icon: '$iuser',
            to: { name: 'ui-profile' },
            text: 'Профиль',
          },
          ...this.associations?.length ? this.associations?.map(({ id, name }) => ({
            icon: '$ui-association',
            to: { name: 'association-dashboard', params: { id } },
            text: name,
            class: 'ui-primary--text',
          })) : [],
        ] : [],
        ...(isOperator || isDepartment) ? [
          ...isOperator ? [{
            text: 'Настройки',
            to: { name: 'ui-settings' },
            icon: '$ui-settings',
          }] : [],
          {
            text: 'Модераторы',
            to: { name: 'ui-moderators' },
            icon: '$ui-user-group',
          },
        ] : [],
        ...isMember ? [
          {
            icon: '$ui-user',
            text: 'Мой профиль',
            to: `${isMember || isExpert ? '/redesign' : ''}/my-profile`,
          },
        ] : [],
        ...isAuthenticated ? [{
          icon: '$iinfo',
          // to: { name: 'ui-instructions' },
          text: 'Инструкции',
          listeners: {
            click: () => this.openInstructions?.(),
          },
        }] : [],
      ];
    },
    connectedRoleItems() {
      const connectedRoles = (this.$user.connectedUsers || [])
        .reduce((acc, user) => {
          if (user?.role) {
            acc.push(user.role);
            return acc;
          }

          acc.push(...(user?.roles || []).map(({ name }) => name));
          return acc;
        }, [])
        .filter(Boolean);

      return [...new Set(connectedRoles)].map((roleKey) => ({
        key: roleKey,
        text: ROLE_CONFIG[roleKey]?.text || roleKey,
        route: ROLE_CONFIG[roleKey]?.route || '/my-profile',
      }));
    },
  },
  methods: {
    async authAsConnectedUser() {
      const connectedUserId = this.connectedToUser?.id;

      if (!connectedUserId) {
        this.$toast.error('Не удалось определить привязанный аккаунт');
        return;
      }

      this.authLoadingRoleKey = CONNECTED_TO_USER_KEY;

      const { response, error } = await this.$rApi.user.authExtenderUser({
        data: {
          user_id: connectedUserId,
        },
      });

      this.authLoadingRoleKey = undefined;

      if (error) {
        return;
      }

      const authData = response?.data?.data;
      if (!authData?.access_token) {
        this.$toast.error('Не удалось авторизоваться под привязанным аккаунтом');
        return;
      }

      await this.$store.dispatch('auth/setAuthData', authData);

      this.menu = false;
      this.roleSwitchOpened = false;

      this.$router.push('/').catch(() => {});
    },
    async authAsConnectedRole(roleItem) {
      const connectedUser = this.$user.getConnectedRoleUser(roleItem.key);
      const connectedUserId = connectedUser?.id;

      if (!connectedUserId) {
        this.$toast.error('Не удалось определить привязанный аккаунт роли');
        return;
      }

      this.authLoadingRoleKey = roleItem.key;

      const { response, error } = await this.$rApi.user.authExtenderUser({
        data: {
          user_id: connectedUserId,
        },
      });

      this.authLoadingRoleKey = undefined;

      if (error) {
        return;
      }

      const authData = response?.data?.data;
      if (!authData?.access_token) {
        this.$toast.error('Не удалось авторизоваться под выбранной ролью');
        return;
      }

      await this.$store.dispatch('auth/setAuthData', authData);

      this.menu = false;
      this.roleSwitchOpened = false;

      this.$router.push('/').catch(() => {});
    },
    logout() {
      this.$dialogs.confirm({
        attrs: {
          method: async () => {
            await this.$store.dispatch('auth/logout');
            this.$router.push('/');
          },
          isRequest: false,
          message: 'Вы уверены, что хотите выйти из учётной записи?',
          closeBtnAttrs: {
            'btn-text': 'Остаться',
          },
          confirmBtnAttrs: {
            'btn-text': 'Выйти',
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header-user-data {
  &__avatar {
    border: 2px solid rgba(0, 0, 0, 0.10);
  }
}
</style>
